<template>
    <div>
        <CCard>
            <CCardHeader>
                <div><h4>Clientes</h4> (ESTE MODULO NO SE UTILIZARÁ MÁS)</div> 
            </CCardHeader>
            <CCardBody>
                
                <CButton type="submit" class="mb-2 btn-class"  
                    @click="mostrarAgregarNuevoCliente = !mostrarAgregarNuevoCliente">
                    {{mostrarAgregarNuevoCliente?"Ocultar":"Agregar Nuevo Cliente"}}
                </CButton>
                <CRow v-show="mostrarAgregarNuevoCliente">
                    <CCol sm="0" md="2"></CCol>
                    <CCol sm="12" md="8">
                        <CCard accent-color="info">
                            <CCardHeader>
                                <h4>Nuevo Cliente</h4>
                            </CCardHeader>
                            <CCardBody>
                                <CInput
                                    v-model="clienteNuevo.rutCliente"
                                    label="Rut"
                                    type="text"
                                    horizontal
                                    placeholder="12345678-9"
                                />
                                <CInput
                                    v-model="clienteNuevo.nombreCliente"
                                    label="Nombre"
                                    type="text"
                                    horizontal
                                />
                                <CInput
                                    v-model="clienteNuevo.rutaCarpetaBd"
                                    label="ruta Carpeta Bd"
                                    type="text"
                                    horizontal
                                />
                                <CInput
                                    v-model="clienteNuevo.carpetaRaiz"
                                    label="Carpeta Raiz"
                                    type="text"
                                    horizontal
                                    placeholder="soloEdig"
                                />
                                <CRow>
                                    <CCol>
                                        <CSwitch
                                            width="150px"
                                            class="mx-1 align-middle mb-2 mt-2" 
                                            color="success" 
                                            shape="pill"
                                            variant="outline"
                                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                            :checked="clienteNuevo.habilitarGesto"
                                            @update:checked="clienteNuevo.habilitarGesto = !clienteNuevo.habilitarGesto"
                                        /> Habilitar Gesto
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol><!--v-c-tooltip.hover="{content:'Habilitar Compartida archivos', placement:'left'}"-->
                                        <CSwitch
                                            width="150px"
                                            class="mx-1 align-middle mb-2 mt-2" 
                                            color="success" 
                                            shape="pill"
                                            variant="outline"
                                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                            :checked="clienteNuevo.habilitarCompartida"
                                            @update:checked="clienteNuevo.habilitarCompartida = !clienteNuevo.habilitarCompartida"
                                        /> Habilitar Compartida
                                    </CCol>
                                </CRow>
                                
                            </CCardBody>
                            <CCardFooter>
                                <CButton type="submit" size="sm" class="btn-class" 
                                    :disabled="isCreandoCliente"
                                    @click="agregarCliente"><!--v-show="userEditados.length>0"  @click="editarUsuarios"-->
                                    <CIcon name="cil-check-circle" :class="isCreandoCliente?'imgr':''"/> Crear Cliente 
                                </CButton>
                                <CIcon
                                class="ml-2"
                                    v-show="mostrarMensajes"
                                    v-tippy="{ 
                                        placement: 'top',
                                        arrow: true, 
                                        arrowType: 'round', 
                                        animation:'fade',
                                        theme: 'google',
                                        followCursor : true,
                                        content: mensajesAgregarCliente
                                    }"
                                    :content="$options.freeSet.cilWarning"
                                />
                            </CCardFooter>
                        </CCard>
                        
                    </CCol>
                </CRow>
                
                <a-table
                    row-key="idCliente"
                    :columns="columnasClientes" 
                    :data-source="clientesData"
                    class="components-table-demo-nested mt-3" 
                    size="small" 
                    style="overflow:auto;"
                    :pagination="{'pageSize': 50, hideOnSinglePage: true}"
                    :loading="isLoadingClientes"
                    @expand="expandirCliente"
                    >

                    <template #loading>
                        <div class="spinner"></div>
                    </template>
                    <slot slot="rutEmpresa" slot-scope="cliente">
                        {{formatearRut(cliente.rutEmpresa)}}
                    </slot>
                    <slot slot="nombreCliente" slot-scope="cliente">
                        {{cliente.nombreCliente}}
                    </slot>
                    <slot slot="rutaCarpetaBd" slot-scope="cliente">
                        {{cliente.rutaCarpetaBd}}
                    </slot>
                    <slot slot="idUnidadDrive" slot-scope="cliente">
                        {{cliente.idUnidadDrive}}
                    </slot>
                    <slot slot="fechaCreacion" slot-scope="cliente">
                        {{formatFecha(cliente.fechaCreacion)}}                        
                    </slot>
                    <slot slot="habilitado" slot-scope="cliente">
                        {{cliente.habilitado?"Si":"No"}}
                        
                    </slot>
                    <span slot="gestoCompartida" slot-scope="cliente">
                        <CIcon style="color:green" name="cil-check-circle" v-show="cliente.habilitarGesto"/>
                        <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.habilitarGesto" />
                        / 
                        <CIcon style="color:green" name="cil-check-circle" v-show="cliente.habilitarCompartida"/>
                        <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.habilitarCompartida" />
                        /
                        <CIcon style="color:green" name="cil-check-circle" v-show="cliente.habilitadoPortalEmpresa"/>
                        <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.habilitadoPortalEmpresa" />
                            
                    </span>
                    <span
                        slot="acciones"
                        slot-scope="cliente">
                        
                            <Modal title="Modificar Cliente" v-model="cliente.editar" :enableClose="false" :modal-style="{'min-width': '300px', 'max-width': '1140px'}">
                                    <div class="vm-content">
                                        
                                        <div v-show="cliente.editar">
                                            <CInput
                                                label="Rut Cliente"
                                                v-model="cliente.rutEmpresa"
                                                type="text"
                                                horizontal
                                                placeholder="Rut Cliente"
                                            />
                                        </div>
                                        <div v-show="cliente.editar">
                                            <CInput
                                                label="Nombre Cliente"
                                                v-model="cliente.nombreCliente"
                                                type="text"
                                                horizontal
                                                placeholder="Id Unidad"
                                            />
                                        </div>
                                        <div v-show="cliente.editar">
                                            
                                            <CInput
                                                label="ruta Carpeta BD"
                                                v-model="cliente.rutaCarpetaBd"
                                                type="text"
                                                horizontal
                                                placeholder="Ruta Carpeta Bd"
                                            />
                                        </div>
                                        <div v-show="cliente.editar">
                                            
                                            <CInput
                                                label="id Unidad Drive"
                                                v-model="cliente.idUnidadDrive"
                                                type="text"
                                                horizontal
                                                placeholder="Id Unidad Drive"
                                            />
                                        </div>
                                        
                                        <div v-show="cliente.editar">
                                            <CInput
                                                label="Nombre Unidad Drive"
                                                v-model="cliente.rutaCarpetaDrive"
                                                type="text"
                                                horizontal
                                                placeholder="Carpeta Defecto Drive"
                                            />
                                        </div>

                                        <div v-show="cliente.editar">
                                            <CInput
                                                label="Carpeta Defecto Drive"
                                                v-model="cliente.carpetaDefectoDrive"
                                                type="text"
                                                horizontal
                                                placeholder="Carpeta Defecto Drive"
                                            />
                                        </div>
                                        
                                        <div v-show="cliente.editar">
                                        Habilitar Cliente
                                        <CSwitch
                                            v-show="cliente.editar"
                                            width="150px"
                                            class="mx-1 align-middle mb-2" 
                                            color="success" 
                                            shape="pill"
                                            variant="outline"
                                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                            :checked="cliente.habilitado"
                                            @update:checked="cliente.habilitado = !cliente.habilitado"
                                        />
                                        </div>
                                        <div>
                                            Habilitar Gesto 
                                            <CSwitch
                                                v-c-tooltip.hover="{content:(cliente.habilitarGesto)?'Deshabilitar Gesto':'Habilitar Gesto', placement:'left'}"
                                                v-show="cliente.editar"
                                                width="150px"
                                                class="mx-1 align-middle mb-2" 
                                                color="success" 
                                                shape="pill"
                                                variant="outline"
                                                v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                :checked="cliente.habilitarGesto"
                                                @update:checked="cliente.habilitarGesto = !cliente.habilitarGesto"
                                            />
                                        </div>
                                        <div>
                                            Habilitar Compartida
                                                <CSwitch
                                                    v-c-tooltip.hover="{content:(cliente.habilitarCompartida)?'Deshabilitar Compartida archivos':'Habilitar Compartida archivos', placement:'left'}"
                                                    v-show="cliente.editar"
                                                    width="150px"
                                                    class="mx-1 align-middle mb-2" 
                                                    color="success" 
                                                    shape="pill"
                                                    variant="outline"
                                                    v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                    :checked="cliente.habilitarCompartida"
                                                    @update:checked="cliente.habilitarCompartida = !cliente.habilitarCompartida"
                                                />
                                        </div>
                                        <div>
                                            Habilitar Portal Empresa
                                                <CSwitch
                                                    v-c-tooltip.hover="{content:(cliente.habilitarCompartida)?'Deshabilitar Compartida archivos':'Habilitar Compartida archivos', placement:'left'}"
                                                    v-show="cliente.editar"
                                                    width="150px"
                                                    class="mx-1 align-middle mb-2" 
                                                    color="success" 
                                                    shape="pill"
                                                    variant="outline"
                                                    v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                    :checked="cliente.habilitadoPortalEmpresa"
                                                    @update:checked="cliente.habilitadoPortalEmpresa = !cliente.habilitadoPortalEmpresa"
                                                />
                                        </div>

                                    </div>
                                    <div class="vm-footer">
                                        <CButtonGroup class="mx-1" v-show="cliente.editar">
                                            <CButton color="success" size="sm" 
                                                :content="'Aceptar Cambios'"                                            
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }"                                          
                                                @click="guardarEdicionCliente(cliente)">
                                                <CIcon name="cil-check-circle"/>
                                            </CButton>
                                            <CButton color="danger" size="sm"
                                                :content="'Cancelar Cambios'"                                            
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }"
                                                @click="cliente.editar=false; cancelarEdicion(cliente)">
                                                <CIcon name="cil-x-circle"/>
                                            </CButton>
                                        </CButtonGroup>
                                    </div>
                            </Modal>
                            <CButtonToolbar >

                                <CButtonGroup size="sm" class="mx-1" v-show="!cliente.editar">
                                    <CButton color="warning" size="sm"
                                        :content="'Editar Cliente'"                                            
                                        v-tippy="{ 
                                            placement: 'top',
                                            arrow: true, 
                                            arrowType: 'round', 
                                            animation:'fade',
                                            theme: 'google',
                                            followCursor : true,
                                        }"
                                        @click="cliente.editar = true;editarCliente(cliente)"
                                    >
                                        <CIcon name="cil-pencil"/>
                                    </CButton>
                                    <CButton color="danger" 
                                        :content="'Eliminar Cliente'"                                            
                                        v-tippy="{ 
                                            placement: 'top',
                                            arrow: true, 
                                            arrowType: 'round', 
                                            animation:'fade',
                                            theme: 'google',
                                            followCursor : true,
                                        }"
                                        @click="eliminarCliente(cliente)"
                                        size="sm" >
                                        <CIcon name="cil-x-circle"/>
                                    </CButton>
                                    <CButton color="primary" 
                                        :content="'Configurar Cliente'"                                            
                                        v-tippy="{ 
                                            placement: 'top',
                                            arrow: true, 
                                            arrowType: 'round', 
                                            animation:'fade',
                                            theme: 'google',
                                            followCursor : true,
                                        }"
                                        @click="configurarCliente(cliente)"
                                        size="sm" ><CIcon name="cilSettings"/>
                                    </CButton>
                                    
                                </CButtonGroup>
                            </CButtonToolbar>
                    </span>
                        
                        <div slot="expandedRowRender" slot-scope="cliente">
                            
                            <CRow>
                                <CCol>
                                    <CTabs>
                                        <CTab active>
                                            <template slot="title">
                                                <CIcon name="cil-user" />
                                                <CBadge color="success" >{{cliente.usuarios.length}}</CBadge>
                                            </template>

                                            <CRow  style="padding: 10px;">
                                                
                                                <CCol md="12">
                                                    <CRow>
                                                        <CCol md="3">
                                                            <CButton size="sm" class="mb-2 btn-class" style="width:auto" @click="cliente.nuevoUsuario=!cliente.nuevoUsuario; monstrarMensajeCreacion = false;">
                                                                <CIcon :content="$options.freeSet.cilSmilePlus" /> {{(cliente.nuevoUsuario)?"Cerrar Creación":"Nuevo Usuario"}}
                                                            </CButton>
                                                        </CCol>
                                                    </CRow>
                                                    <CRow v-show="cliente.nuevoUsuario">
                                                        <CCol sm="0" md="2"></CCol>
                                                        <CCol sm="12" md="8">
                                                            <CrearUsuario :crudPrincipal="this" :cliente="cliente" />
                                                        </CCol>
                                                        <CCol sm="0" md="2"></CCol>
                                                    </CRow>
                                                    <CRow>
                                                        <CCol>
                                                            <a-table
                                                                row-key="userName"
                                                                :columns="columnsUsuarios" 
                                                                :data-source="cliente.usuarios"
                                                                :pagination="{ pageSize: 30, hideOnSinglePage: true }"
                                                                :scroll="{ y: 270 }"
                                                                :loading="isLoadingUsuarios"
                                                                class="components-table-demo-nested m-1" 
                                                                size="small" 
                                                                style="overflow:auto;">

                                                                <span 
                                                                    slot="rutUsuario"
                                                                    slot-scope="record">
                                                                    <div v-show="!record.editar">
                                                                        {{record.userPropio?"(Yo)":""}} {{record.rutUsuario}}
                                                                    </div>
                                                                    
                                                                    <div v-show="record.editar">
                                                                        <CInput
                                                                            v-model="record.rutUsuario"
                                                                            type="text"
                                                                            horizontal
                                                                            placeholder="Rut Usuario"
                                                                            :is-valid="record.rutValidadoUser"
                                                                            @blur="validarRut(record.rutUsuario, record)"
                                                                        />
                                                                    </div>
                                                                </span>

                                                                <span 
                                                                slot="userName"
                                                                slot-scope="record">
                                                                    <div v-show="!record.editar">
                                                                        {{record.userName}}
                                                                    </div>
                                                                    
                                                                </span>

                                                                <span slot="nombreUsuario"
                                                                    slot-scope="record">
                                                                    <div v-show="!record.editar">
                                                                        {{record.nombreUsuario}} {{record.apellidoUsuario}}
                                                                    </div>
                                                                    
                                                                    
                                                                </span>

                                                                <span slot="mailUsuario"
                                                                slot-scope="record">
                                                                    <div v-show="!record.editar">
                                                                        {{record.mailUsuario}}
                                                                    </div>
                                                                    
                                                                    
                                                                </span>

                                                                <span slot="habilitado"
                                                                    slot-scope="record">
                                                                    <div v-show="!record.editar">
                                                                        
                                                                        <CIcon style="color:green" name="cil-check-circle" v-show="record.habilitado"/>
                                                                        <CIcon style="color:red" name="cil-x-circle" v-show="!record.habilitado" />
                                                                    </div>
                                                                    
                                                                </span>

                                                                <span slot="tipoUser"
                                                                    slot-scope="record">
                                                                    <div v-show="!record.editar">
                                                                        {{(record.usuarioAdmin)?"Admin":(record.usuarioRevision?"Revisión":"Normal")}}
                                                                    </div>
                                                                    

                                                                </span>

                                                                <span slot="eliminado" slot-scope="record">
                                                                    <div v-show="!record.editar">
                                                                        <CIcon style="color:red" name="cil-check-circle" v-show="record.usuarioEliminado"/>
                                                                        <CIcon style="color:green" name="cil-x-circle" v-show="!record.usuarioEliminado" />
                                                                    </div>
                                                                    
                                                                </span>
                                                                <span slot="habilitadoCompartir" slot-scope="usuario">
                                                                    <div v-show="!usuario.editar">
                                                                        <CIcon style="color:green" name="cil-check-circle" v-show="usuario.habilitadoCompartir"/>
                                                                        <CIcon style="color:red" name="cil-x-circle" v-show="!usuario.habilitadoCompartir" />
                                                                    </div>
                                                                </span>

                                                                <span slot="acciones"
                                                                    slot-scope="usuario">
                                                                    <Modal title="Modificar Usuario" v-model="usuario.editar" :enableClose="false" :modal-style="{'min-width': '300px', 'max-width': '1140px'}">
                                                                        <div class="vm-content">                                                                            
                                                                            <CInput
                                                                                label="Nombre Usuario"
                                                                                v-model="usuario.userName"
                                                                                type="text"
                                                                                horizontal
                                                                                placeholder="Nombre Usuario"
                                                                            />
                                                                            
                                                                            <CInput
                                                                                label="Nombre"
                                                                                v-model="usuario.nombreUsuario"
                                                                                type="text"
                                                                                horizontal
                                                                                placeholder="Nombre"
                                                                            />
                                                                            <CInput
                                                                                label="Apellido"
                                                                                v-model="usuario.apellidoUsuario"
                                                                                type="text"
                                                                                horizontal
                                                                                placeholder="Apellido"
                                                                            />
                                                                            <CInput
                                                                                label="Correo"
                                                                                v-model="usuario.mailUsuario"
                                                                                type="text"
                                                                                horizontal
                                                                                placeholder="Correo"
                                                                                :is-valid="usuario.mailValidoUser"
                                                                                @blur="validarCampos(usuario)"
                                                                                @keydown="validarMaximo($event,usuario.mailUsuario,'mail')"
                                                                            />
                                                                            <br>
                                                                            <CRow>
                                                                                <CCol sm="1">
                                                                                    <CSwitch
                                                                                        width="150px"
                                                                                        class="mx-1 align-middle mb-2" 
                                                                                        color="success" 
                                                                                        shape="pill"
                                                                                        variant="outline"
                                                                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                                                        :checked="usuario.habilitado"
                                                                                        @update:checked="usuario.habilitado = !usuario.habilitado"
                                                                                    />
                                                                                </CCol>
                                                                                <CCol sm="3"> Usuario Habilitado</CCol>
                                                                            </CRow>
                                                                            <CRow>
                                                                                <CCol sm="1">
                                                                                    <CSwitch
                                                                                        width="150px"
                                                                                        class="mx-1 align-middle mb-2" 
                                                                                        color="success" 
                                                                                        shape="pill"
                                                                                        variant="outline"
                                                                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                                                        :checked="usuario.usuarioAdmin"
                                                                                        @update:checked="usuario.usuarioAdmin = !usuario.usuarioAdmin; validarTipoUsuarioEdit('admin',usuario.usuarioAdmin,usuario)"
                                                                                    />
                                                                                </CCol>
                                                                                <CCol sm="3">
                                                                                    Admin
                                                                                </CCol>
                                                                            </CRow>
                                                                            <CRow>
                                                                                <CCol sm="1">
                                                                                    <CSwitch
                                                                                        width="150px"
                                                                                        class="mx-1 align-middle mb-2" 
                                                                                        color="success" 
                                                                                        shape="pill"
                                                                                        variant="outline"
                                                                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                                                        :checked="usuario.usuarioNormal"
                                                                                        @update:checked="usuario.usuarioNormal = !usuario.usuarioNormal; validarTipoUsuarioEdit('normal',usuario.usuarioNormal,usuario)"
                                                                                    />
                                                                                    </CCol>
                                                                                <CCol sm="3">
                                                                                    Normal
                                                                                </CCol>
                                                                            </CRow>
                                                                            <CRow>
                                                                                <CCol sm="1">
                                                                                    <CSwitch
                                                                                        width="150px"
                                                                                        class="mx-1 align-middle mb-2" 
                                                                                        color="success" 
                                                                                        shape="pill"
                                                                                        variant="outline"
                                                                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                                                        :checked="usuario.usuarioRevision"
                                                                                        @update:checked="usuario.usuarioRevision = !usuario.usuarioRevision; validarTipoUsuarioEdit('revision',usuario.usuarioRevision, usuario)"
                                                                                    />
                                                                                </CCol>
                                                                                <CCol sm="3">
                                                                                    Revision
                                                                                </CCol>
                                                                            </CRow>
                                                                            <CRow>
                                                                                <CCol sm="1">
                                                                                    <CSwitch
                                                                                        width="150px"
                                                                                        class="mx-1 align-middle mb-2" 
                                                                                        color="success" 
                                                                                        shape="pill"
                                                                                        variant="outline"
                                                                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                                                        :checked="usuario.usuarioEliminado"
                                                                                        @update:checked="usuario.usuarioEliminado = !usuario.usuarioEliminado"
                                                                                    />
                                                                                </CCol>
                                                                                <CCol sm="3">
                                                                                    Usuario Eliminado
                                                                                </CCol>
                                                                            </CRow>
                                                                            <CRow>
                                                                                <CCol sm="1">
                                                                                    <CSwitch
                                                                                        :content="'Deshabilitar/Habilitar Compartida archivos'"
                                                                                        v-tippy="{ 
                                                                                    placement: 'top',
                                                                                    arrow: true, 
                                                                                    arrowType: 'round', 
                                                                                    animation:'fade',
                                                                                    theme: 'google',
                                                                                    followCursor : true,
                                                                                }"
                                                                                        v-show="usuario.editar"
                                                                                        width="150px"
                                                                                        class="mx-1 align-middle mb-2" 
                                                                                        color="success" 
                                                                                        shape="pill"
                                                                                        variant="outline"
                                                                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                                                        :checked="usuario.habilitadoCompartir"
                                                                                        @update:checked="usuario.habilitadoCompartir = !usuario.habilitadoCompartir"
                                                                                    />
                                                                                </CCol>
                                                                                <CCol sm="3">
                                                                                    Habilitar Compartir
                                                                                </CCol>
                                                                            </CRow>
                                                                        </div>
                                                                        <div class="vm-footer">
                                                                            
                                                                            <CButtonGroup class="mx-1" v-show="usuario.editar && !usuario.eliminar">
                                                                                <CButton color="success" size="sm"
                                                                                    :content="'Aceptar Cambios'"
                                                                                    v-tippy="{ 
                                                                                    placement: 'top',
                                                                                    arrow: true, 
                                                                                    arrowType: 'round', 
                                                                                    animation:'fade',
                                                                                    theme: 'google',
                                                                                    followCursor : true,
                                                                                }"
                                                                                    :disabled="!usuario.rutValidadoUser 
                                                                                    || !usuario.mailValidoUser 
                                                                                    || !usuario.userName.length>0
                                                                                    || !usuario.nombreUsuario.length>0
                                                                                    || !usuario.apellidoUsuario.length>0"
                                                                                    @click="guardarEdicionUsuario(usuario)">
                                                                                    <CIcon name="cil-check-circle"/><!-- Aceptar-->
                                                                                </CButton>
                                                                                <CButton color="danger" size="sm"
                                                                                    :content="'Cancelar Cambios'"
                                                                                    v-tippy="{ 
                                                                                    placement: 'top',
                                                                                    arrow: true, 
                                                                                    arrowType: 'round', 
                                                                                    animation:'fade',
                                                                                    theme: 'google',
                                                                                    followCursor : true,
                                                                                }"
                                                                                    @click="usuario.editar=false; cancelarEdicion(usuario)">
                                                                                    <CIcon name="cil-x-circle"/><!-- Revisar -->
                                                                                </CButton>
                                                                            </CButtonGroup>
                                                                        </div>
                                                                    </Modal>
                                                                    <CButtonToolbar >
                                                                        <CAlert v-show="usuario.eliminar" color="danger">
                                                                            ¿Está seguro?
                                                                            <CButtonGroup class="mx-1">
                                                                                <CButton color="success" size="sm"
                                                                                    :content="'Si, Eliminar'"
                                                                                    v-tippy="{ 
                                                                                    placement: 'top',
                                                                                    arrow: true, 
                                                                                    arrowType: 'round', 
                                                                                    animation:'fade',
                                                                                    theme: 'google',
                                                                                    followCursor : true,
                                                                                }"
                                                                                    @click="eliminarUsuarioCliente(usuario)">
                                                                                    <CIcon name="cil-check-circle"/><!-- Si!-->
                                                                                </CButton>

                                                                                <CButton color="danger" size="sm"
                                                                                    :content="'No!'"
                                                                                    v-tippy="{ 
                                                                                    placement: 'top',
                                                                                    arrow: true, 
                                                                                    arrowType: 'round', 
                                                                                    animation:'fade',
                                                                                    theme: 'google',
                                                                                    followCursor : true,
                                                                                }"
                                                                                    @click="usuario.eliminar = false">
                                                                                    <CIcon name="cil-x-circle"/><!-- No!-->
                                                                                </CButton>
                                                                            </CButtonGroup>
                                                                        </CAlert>
                                                                        


                                                                        <CButtonGroup size="sm" class="mx-1" v-show="!usuario.editar && !usuario.eliminar">
                                                                            <CButton color="warning" size="sm"
                                                                                :content="'Editar Usuario'"
                                                                                v-tippy="{ 
                                                                                    placement: 'top',
                                                                                    arrow: true, 
                                                                                    arrowType: 'round', 
                                                                                    animation:'fade',
                                                                                    theme: 'google',
                                                                                    followCursor : true,
                                                                                }"
                                                                                @click="usuario.editar = true; editarUser(usuario)">
                                                                                <CIcon name="cil-pencil"/><!-- Editar-->
                                                                            </CButton>
                                                                            <CButton color="danger" 
                                                                                :content="'Eliminar Usuario'"
                                                                                v-tippy="{ 
                                                                                    placement: 'top',
                                                                                    arrow: true, 
                                                                                    arrowType: 'round', 
                                                                                    animation:'fade',
                                                                                    theme: 'google',
                                                                                    followCursor : true,
                                                                                }"
                                                                                @click="usuario.eliminar = true" size="sm" ><CIcon name="cil-x-circle"/><!-- Eliminar-->
                                                                            </CButton>
                                                                        </CButtonGroup>
                                                                        
                                                                    </CButtonToolbar>
                                                                </span>
                                                            </a-table>
                                                        </CCol>
                                                    </CRow>
                                                </CCol>
                                            </CRow>
                                            
                                        </CTab>
                                        <CTab>
                                            <template slot="title" >
                                                <CIcon name="cil-settings" />
                                            </template>
                                            
                                            <CRow style="padding: 10px;">
                                                
                                                <CCol col="8">
                                                    <CCard>
                                                        <CCardHeader 
                                                            @click="verOpcionesClientes = !verOpcionesClientes" 
                                                            class="btn text-left"
                                                            > 
                                                            <strong>Configuración Módulos</strong>
                                                        </CCardHeader>
                                                        <CCollapse :show="verOpcionesClientes">
                                                            <CCardBody class="m-1">
                                                                configurar Modulos
                                                            </CCardBody>
                                                        </CCollapse>
                                                    </CCard>
                                                    <CCard>
                                                        <CCardHeader 
                                                            @click="verPropClientes = !verPropClientes" 
                                                            class="btn text-left"> 
                                                            <strong>Propiedades Cliente</strong>
                                                        </CCardHeader>
                                                        <CCollapse :show="verPropClientes">
                                                            <CCardBody class="m-1">
                                                                <CRow style="padding: 10px;">
                                                                    <CCol col="12">
                                                                        <!--<CButton type="submit" class="mb-2 btn-class"  
                                                                            @click="getConfigCliente(cliente)">
                                                                            Obtener Configuración
                                                                        </CButton>
                                                                        asd
                                                                        {{cliente}}-->
                                                                        <CRow><CCol><h4>Propiedades Cliente</h4></CCol></CRow>
                                                                        <CRow>
                                                                            <CCol sm="4">
                                                                                <!--<CSwitch
                                                                                    width="150px"
                                                                                    class="mx-1 align-middle mb-2" 
                                                                                    color="success" 
                                                                                    shape="pill"
                                                                                    variant="outline"
                                                                                    v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                                                    :checked="record.habilitado"
                                                                                    @update:checked="record.habilitado = !record.habilitado"
                                                                                />-->
                                                                                <multiselect class="m-0 d-inline-block mb-2"
                                                                                    :id="cliente"
                                                                                    v-model="cliente.propiedadSeleccionada"
                                                                                    deselect-label="" 
                                                                                    label="nombrePropiedad" 
                                                                                    placeholder="Propiedad" 
                                                                                    select-label=""
                                                                                    selectedLabel=""
                                                                                    :options="cliente.propiedadesCliente"
                                                                                    :searchable="true"
                                                                                    @select="seleccionarPropiedad"
                                                                                >
                                                                                </multiselect>
                                                                            </CCol>
                                                                            <CCol sm="3">
                                                                                <CRow v-if="cliente.propiedadSeleccionada != null && cliente.propiedadSeleccionada.nombrePropiedad == 'tablas_REMU'">
                                                                                    <CCol col="12">
                                                                                        <CRow v-for="tabla in cliente.tablasBase.tablasBaseRemu" :key="tabla.nombreTabla">
                                                                                            <CCol>
                                                                                                <CIcon style="color:green" name="cil-check-circle" v-show="!cliente.propiedadSeleccionada.editarPropiedad" v-if="tabla.agregada"/>
                                                                                                <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.propiedadSeleccionada.editarPropiedad" v-else />
                                                                                                <CSwitch
                                                                                                    v-show="cliente.propiedadSeleccionada.editarPropiedad"
                                                                                                    width="150px"
                                                                                                    class="mx-1 align-middle mb-2" 
                                                                                                    color="success" 
                                                                                                    shape="pill"
                                                                                                    variant="outline"
                                                                                                    v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                                                                    :checked="tabla.agregada"
                                                                                                    @update:checked="tabla.agregada = !tabla.agregada"
                                                                                                /> {{tabla.nombreTabla}}
                                                                                            </CCol>

                                                                                            <!--<CCol col="6" v-show="!cliente.propiedadSeleccionada.editarPropiedad">
                                                                                                
                                                                                                
                                                                                            </CCol>
                                                                                            
                                                                                            <CCol v-show="cliente.propiedadSeleccionada.editarPropiedad">
                                                                                                <CSwitch
                                                                                                    width="150px"
                                                                                                    class="mx-1 align-middle mb-2" 
                                                                                                    color="success" 
                                                                                                    shape="pill"
                                                                                                    variant="outline"
                                                                                                    v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                                                                    :checked="tabla.agregada"
                                                                                                    @update:checked="tabla.agregada = !tabla.agregada"
                                                                                                />
                                                                                            
                                                                                            </CCol>-->
                                                                                        </CRow>
                                                                                    </CCol>
                                                                                </CRow>
                                                                                <CRow v-else-if="cliente.propiedadSeleccionada != null && cliente.propiedadSeleccionada.nombrePropiedad == 'tablas_CONTA'">
                                                                                    <CCol col="12">
                                                                                        <CRow v-for="tabla in cliente.tablasBase.tablasBaseConta" :key="tabla.nombreTabla">
                                                                                            <CCol>
                                                                                                <CIcon style="color:green" name="cil-check-circle" v-show="!cliente.propiedadSeleccionada.editarPropiedad" v-if="tabla.agregada"/>
                                                                                                <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.propiedadSeleccionada.editarPropiedad" v-else />
                                                                                                <CSwitch
                                                                                                    v-show="cliente.propiedadSeleccionada.editarPropiedad"
                                                                                                    width="150px"
                                                                                                    class="mx-1 align-middle mb-2" 
                                                                                                    color="success" 
                                                                                                    shape="pill"
                                                                                                    variant="outline"
                                                                                                    v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                                                                    :checked="tabla.agregada"
                                                                                                    @update:checked="tabla.agregada = !tabla.agregada"
                                                                                                /> {{tabla.nombreTabla}}
                                                                                            </CCol>

                                                                                        </CRow>
                                                                                    </CCol>
                                                                                </CRow>
                                                                                <CRow v-show="cliente.propiedadSeleccionada != null" v-else>
                                                                                    <CCol col="12" v-show="cliente.propiedadSeleccionada != null && !cliente.propiedadSeleccionada.editarPropiedad">
                                                                                        <CInput
                                                                                            v-if="cliente.propiedadSeleccionada != null"
                                                                                            style="margin-top:0"
                                                                                            v-model="cliente.propiedadSeleccionada.valorPropiedad"
                                                                                            plaintext
                                                                                        />
                                                                                    </CCol>
                                                                                    <CCol col="12" v-show="cliente.propiedadSeleccionada != null && cliente.propiedadSeleccionada.editarPropiedad">
                                                                                        <CInput
                                                                                            v-if="cliente.propiedadSeleccionada != null"
                                                                                            style="margin-top:0"
                                                                                            v-model="cliente.propiedadSeleccionada.valorPropiedad"
                                                                                            type="text"
                                                                                        />
                                                                                    </CCol>
                                                                                </CRow>
                                                                            </CCol>
                                                                            <CCol col="2">
                                                                                
                                                                                <CButtonGroup size="sm" v-show="cliente.propiedadSeleccionada != null && cliente.propiedadSeleccionada.eliminarPropiedad">
                                                                                    <CButton color="warning" size="sm"
                                                                                        v-c-tooltip.hover="{content:'Está Seguro?', placement:'left'}"
                                                                                        @click="eliminarPropiedad(cliente)">
                                                                                        <CIcon name="cil-check-circle"/>
                                                                                    </CButton>
                                                                                    <CButton color="danger" 
                                                                                    v-c-tooltip.hover="{content:'No!', placement:'right'}"
                                                                                    @click="cliente.propiedadSeleccionada.eliminarPropiedad = false"
                                                                                    size="sm" ><CIcon name="cil-x-circle"/>
                                                                                    </CButton>
                                                                                    
                                                                                </CButtonGroup>
                                                                                
                                                                                <CButtonGroup size="sm" v-show="cliente.propiedadSeleccionada != null && !cliente.propiedadSeleccionada.editarPropiedad && !cliente.propiedadSeleccionada.eliminarPropiedad">
                                                                                    <CButton color="warning" size="sm"
                                                                                        v-c-tooltip.hover="{content:'Editar Propiedad', placement:'left'}"
                                                                                        @click="cliente.propiedadSeleccionada.editarPropiedad=true">
                                                                                        <CIcon name="cil-pencil"/>
                                                                                    </CButton>
                                                                                    <CButton color="danger" 
                                                                                    v-c-tooltip.hover="{content:'Eliminar Propiedad', placement:'down'}"
                                                                                    @click="cliente.propiedadSeleccionada.eliminarPropiedad = true"
                                                                                    size="sm" ><CIcon name="cil-x-circle"/>
                                                                                    </CButton>
                                                                                    
                                                                                </CButtonGroup>
                                                                                <CButtonGroup class="mx-1" v-show="cliente.propiedadSeleccionada != null && cliente.propiedadSeleccionada.editarPropiedad">
                                                                                    <CButton color="success" size="sm"
                                                                                        v-if="cliente.propiedadSeleccionada != null"
                                                                                        :disabled="cliente.propiedadSeleccionada == null && cliente.propiedadSeleccionada.valorPropiedad.length==0 || cliente.propiedadSeleccionada.nombrePropiedad.length==0"
                                                                                        v-c-tooltip.hover="{content:'Guardar', placement:'left'}"
                                                                                        @click="modificarPropiedad(cliente)">
                                                                                        <CIcon name="cil-check-circle"/>
                                                                                    </CButton>
                                                                                    <CButton color="danger" size="sm"
                                                                                        v-if="cliente.propiedadSeleccionada != null"
                                                                                        v-c-tooltip.hover="{content:'Cancelar Cambios', placement:'right'}"
                                                                                        @click="cliente.propiedadSeleccionada.editarPropiedad=false">
                                                                                        <CIcon name="cil-x-circle"/>
                                                                                    </CButton>
                                                                                </CButtonGroup>
                                                                                
                                                                                <!--
                                                                                <CButtonGroup class="mx-1" 
                                                                                    :style="(cliente.propiedadSeleccionada != null && cliente.propiedadSeleccionada.nuevaPropiedad)?'margin-top: 30%':''" 
                                                                                    v-show="cliente.propiedadSeleccionada != null && (cliente.propiedadSeleccionada.editarPropiedad || cliente.propiedadSeleccionada.nuevaPropiedad)">
                                                                                    <CButton color="success" size="sm"
                                                                                        :disabled="cliente.propiedadSeleccionada != null && cliente.propiedadSeleccionada.valorPropiedad.length==0 || cliente.propiedadSeleccionada.nombrePropiedad.length==0"
                                                                                        v-c-tooltip.hover="{content:'Guardar', placement:'left'}"
                                                                                        @click="(cliente.propiedadSeleccionada.nuevaPropiedad)?guardarNuevaPropiedad(cliente,cliente.propiedadSeleccionada):modificarPropiedad(cliente,cliente.propiedadSeleccionada)">
                                                                                        <CIcon name="cil-check-circle"/>
                                                                                    </CButton>
                                                                                    <CButton color="danger" size="sm"
                                                                                        v-c-tooltip.hover="{content:'Cancelar Cambios', placement:'right'}"
                                                                                        @click="(cliente.propiedadSeleccionada.nuevaPropiedad)?quitarPropiedadNueva(cliente, cliente.propiedadSeleccionada):propiedad.editarPropiedad=false;">
                                                                                        <CIcon name="cil-x-circle"/>
                                                                                    </CButton>
                                                                                </CButtonGroup>
                                                                                -->
                                                                            </CCol>
                                                                        </CRow>
                                                                        <CRow v-show="cliente.agregarNuevaPropiedad">
                                                                            <CCol col="3">
                                                                                <CInput
                                                                                    label="Nombre Propiedad"
                                                                                    style="margin-top:10px"
                                                                                    v-model="cliente.nuevaPropiedad.nombrePropiedad"
                                                                                    type="text"
                                                                                />
                                                                            </CCol>
                                                                            <CCol col="7">
                                                                                <CInput
                                                                                    label="Valor Propiedad"
                                                                                    style="margin-top:10px"
                                                                                    v-model="cliente.nuevaPropiedad.valorPropiedad"
                                                                                    type="text"
                                                                                />
                                                                            </CCol>
                                                                            <CCol col="2">
                                                                                <CButtonGroup class="mx-1" :style="(cliente.agregarNuevaPropiedad)?'margin-top: 35px':''">
                                                                                    <CButton color="success" size="sm"
                                                                                        :disabled="cliente.nuevaPropiedad.valorPropiedad.length==0 || cliente.nuevaPropiedad.nombrePropiedad.length==0"
                                                                                        v-c-tooltip.hover="{content:'Guardar', placement:'left'}"
                                                                                        @click="guardarNuevaPropiedad(cliente)">
                                                                                        <CIcon name="cil-check-circle"/>
                                                                                    </CButton>
                                                                                    <CButton color="danger" size="sm"
                                                                                        v-c-tooltip.hover="{content:'Cancelar Cambios', placement:'right'}"
                                                                                        @click="quitarPropiedadNueva(cliente)">
                                                                                        <CIcon name="cil-x-circle"/>
                                                                                    </CButton>
                                                                                </CButtonGroup>
                                                                            </CCol>
                                                                        </CRow>
                                                                        <CButton type="submit" class="mt-3 mb-2 btn-class"  
                                                                            @click="agregarNuevaPropiedad(cliente)">
                                                                            <CIcon :content="$options.freeSet.cilPlus" /> Nueva propiedad
                                                                        </CButton>

                                                                    </CCol>
                                                                </CRow>
                                                            </CCardBody>
                                                        </CCollapse>
                                                    </CCard>
                                                </CCol>
                                            </CRow>
                                            

                                        </CTab>

                                        <CTab>
                                            <template slot="title" >
                                                <CIcon :content="$options.freeSet.cilLoopCircular" /><!--name="$options.freeSet.cilLoopCircular"-->
                                            </template>
                                            <CRow style="padding: 10px;">
                                                <CCol col="3">
                                                    <multiselect class="m-0 d-inline-block mb-2"
                                                        :id="cliente"
                                                        v-model="cliente.tipoBdSelected"
                                                        deselect-label="" 
                                                        label="nombreTipoBd" 
                                                        placeholder="TipoBd" 
                                                        select-label=""
                                                        selectedLabel=""
                                                        :options="tiposBd" 
                                                        :searchable="true"
                                                        @select="getEmpresasCliente"
                                                    >
                                                    </multiselect>
                                                </CCol>
                                                <CCol col="4">
                                                    <CButton type="submit" class="mb-2 btn-class"  
                                                        @click="actualizarEmpresasCliente(cliente)"
                                                        v-show="cliente.empresas.length == 0 && !cliente.isLoadingEmpresas && cliente.tipoBdSelected != null">
                                                        Actualizar Empresas
                                                    </CButton>

                                                    <CButton type="submit" class="mb-2 btn-class"
                                                        v-show="cliente.empresas.length > 0 && !cliente.isLoadingEmpresas && cliente.tipoBdSelected != null"
                                                        
                                                        @click="actualizarTodoBd(cliente)">
                                                        <CIcon v-show="cliente.isUpdtEmpresas" :content="$options.freeSet.cilLoopCircular" /> Actualizar Todo
                                                    </CButton>
                                                </CCol>
                                                <CCol col="3">
                                                    
                                                </CCol>
                                                <!--<CCol col="3">
                                                    <CButton 
                                                        style="width: 100%;"
                                                        class="btnPrincipalVapp"
                                                        size="sm" 
                                                        @click="actualizarBD(cliente)">
                                                        <CIcon :content="$options.freeSet.cilLoopCircular" /> Actualizar BD
                                                    </CButton>
                                                </CCol>
                                                <CCol col="3">
                                                <CButton 
                                                        style="width: 100%;"
                                                        class="btnPrincipalVapp"
                                                        size="sm" >
                                                        <CIcon :content="$options.freeSet.cilLoopCircular" /> Actualizar Documentos
                                                    </CButton>
                                                </CCol>
                                                <CCol col="3">
                                                <CButton 
                                                        style="width: 100%;"
                                                        class="btnPrincipalVapp"
                                                        size="sm" >
                                                        <CIcon :content="$options.freeSet.cilLoopCircular" /> Actualizar Trabajadores
                                                    </CButton>
                                                </CCol>-->
                                            </CRow>
                                            <CRow>
                                                
                                                <CCol sm="12">
                                                    <CSwitch
                                                        width="150px"
                                                        class="mx-1 align-middle mb-2" 
                                                        color="success" 
                                                        shape="pill"
                                                        variant="outline"
                                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                        :checked="cliente.soloFiltradasCliente"
                                                        @update:checked="cliente.soloFiltradasCliente = !cliente.soloFiltradasCliente; getEmpresasCliente(cliente.tipoBdSelected, cliente)"
                                                    /> Mostrar solo empresas habilitadas cliente
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol sm="12">
                                                    <a-table
                                                        :columns="columnsEmpresas" 
                                                        :data-source="cliente.empresas"
                                                        :scroll="{ y: 400 }"
                                                        :loading="cliente.isLoadingEmpresas"
                                                        class="components-table-demo-nested mt-3" 
                                                        size="small" 
                                                        style="overflow:auto;">

                                                        <span slot="customTitle">
                                                            Nombre Empresa
                                                        </span>
                                                        
                                                        <slot slot="habEmpresa" slot-scope="empresa">
                                                            <CIcon style="color:green" name="cil-check-circle" v-show="empresa.habilitadoCliente"/>
                                                            <CIcon style="color:red" name="cil-x-circle" v-show="!empresa.habilitadoCliente" />
                                                        </slot>
                                                        <span slot="rutEmpresa" slot-scope="empresa">
                                                            {{formatearRut(empresa.rutEmpresa)}}
                                                        </span>
                                                        
                                                        <span slot="nombreEmpresa" slot-scope="empresa">
                                                            ({{empresa.codEmpresa}}) {{empresa.nombreEmpresa}}
                                                        </span>
                                                        <span slot="msjAct" slot-scope="empresa" :alt="empresa.mensajeUltimaActualizacion">
                                                            {{empresa.mensajeUltimaActualizacion}}
                                                        </span>
                                                        <span slot="acciones" slot-scope="empresa">
                                                            <CButton 
                                                                class="btnPrincipalVapp"
                                                                size="sm"
                                                                v-c-tooltip.hover="{content:'Actualizar BD Empresa', placement:'left'}"
                                                                :disabled="empresa.actualizandoEmpresa"
                                                                @click="actualizarBDEmpresa(cliente, empresa)">
                                                                <CIcon :content="$options.freeSet.cilLoopCircular" :class="empresa.actualizandoEmpresa?'imgr':''" />
                                                            </CButton>
                                                            
                                                            <CButton v-show="empresa.mensajeActualizacion != null"
                                                                class="ml-1 btnPrincipalVapp"
                                                                size="sm"
                                                                @click="mostrarMensajeActualizacion(empresa)">
                                                                <CIcon :content="$options.freeSet.cilListRich" />
                                                            </CButton>
                                                        </span>
                                                    </a-table>
                                                </CCol>
                                            </CRow>
                                        </CTab>
                                        <!--<CTab>
                                            <template slot="title">
                                            <CIcon name="cil-chart-pie"/>
                                            </template>
                                            3. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore
                                            et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                            aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                                            dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
                                            officia deserunt mollit anim id est laborum.
                                        </CTab>-->
                                    </CTabs>
                                </CCol>
                            </CRow>
                        </div>
                </a-table>
            </CCardBody>
        <CCardFooter>
            
        </CCardFooter>
    </CCard>
    <!--<Modal title="Modificar Cliente" v-model="modificarClienteModal" :modal-style="{'min-width': '300px', 'max-width': '1140px'}">
            
            <div class="vm-content">
                {{ clienteModificar }}
            </div>
            <div class="vm-footer">
                <CButton type="submit" size="sm" color="danger" class="float-right" 
                        @click="modificarClienteModal = false">
                        <CIcon name="cil-x-circle"/> Salir
                    </CButton>
            </div>
        </Modal>-->
    <Modal title="Mensajes Actualización" v-model="empresaMostrarMensaje" :modal-style="{'min-width': '300px', 'max-width': '1140px'}">
            
            <div class="vm-content">
                <a-table
                    :row-key="empresaAmostrar => empresaMostrarMensaje.idEmpresa"
                    :columns="columnasMensajesAct" 
                    :data-source="mensajesActualizacion"
                    :scroll="{ y: 300 }"
                    class="components-table-demo-nested mt-3" 
                    size="small" 
                    style="overflow:auto;">
                        <slot slot="mensajes" slot-scope="mensaje">
                            <CAlert show color="info" :key="index" v-for="(msj, index) in mensaje.mensajes">
                                {{msj.mensaje}}
                            </CAlert>
                        </slot>
                </a-table>
            </div>
            <div class="vm-footer">
                
            </div>
        </Modal>
    
  </div>
</template>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    import cons from "@/const";
    import axios from "axios";
    import Multiselect from "vue-multiselect";
    import CrearUsuario from "./CrearUsuarioClienteAdmin.vue";

    import VueModal from "@kouts/vue-modal";
    import "@kouts/vue-modal/dist/vue-modal.css";

    import { freeSet } from "@coreui/icons";


    import { format, formatDistance, formatRelative, subDays } from "date-fns";
    import es from "date-fns/locale/es";
    window.locale = "es";

    export default {
        name: "ClientesAdmin",
        freeSet,
        components: {
            Multiselect,
            Modal: VueModal,
            CrearUsuario
        },

        data() {
            return {
                baseUrl: cons.protocolo+"://" + cons.ipServer + cons.puerto,

                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,
                tiempoRestanteSesion: cons.tiempoRestanteSesion,

                regMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,

                mostrarAgregarNuevoCliente: false,
                clienteNuevo: {
                    "rutCliente": "",
                    "nombreCliente": "",
                    "rutaCarpetaBd": "",
                    "idUnidadDrive": "",
                    "carpetaRaiz": "",
                    "habilitarGesto": false,
                    "habilitarCompartida": false
                },

                options: ['Option 1', 'Option 2', 'Option 3'],
                option: null,

                clientesData: [],
                mensajesAgregarCliente: "",
                mostrarMensajes: false,

                tipoBdSelected: null,
                tiposBd: [
                    {
                        "idTipoBd": "REMU",
                        "nombreTipoBd": "Remuneraciones"
                    },
                    {
                        "idTipoBd": "CONTA",
                        "nombreTipoBd": "Contabilidad"
                    }
                ],
                isCreandoCliente: false,
                isLoadingClientes: false,
                isLoadingUsuarios: false,

                columnasClientes: [
                    { title: 'Id', dataIndex: 'idCliente', key: 'idCliente', width: '5%', align: 'center'},
                    { title: 'Rut', scopedSlots: { customRender: 'rutEmpresa' }, width: '10%', align: 'left'},
                    { title: 'Nombre Cliente', scopedSlots: { customRender: 'nombreCliente' }, width: '20%', align: 'left'},
                    { title: 'Ruta Bd (Edig)', scopedSlots: { customRender: 'rutaCarpetaBd' }, width: '15%', align: 'left'},
                    { title: 'Id Unidad Google Drive', scopedSlots: { customRender: 'idUnidadDrive' }, width: '15%', align: 'left'},
                    { title: 'Creado',scopedSlots: { customRender: 'fechaCreacion' }, width: '10%', align: 'left'},
                    { title: 'Habilitado', scopedSlots: { customRender: 'habilitado' }, width: '5%', align: 'center'},
                    { title: 'Gesto/Compartida/P. Emp', scopedSlots: { customRender: 'gestoCompartida' }, width: '10%', align: 'center'},
                    { title: 'Acciones', scopedSlots: { customRender: 'acciones' }, width: '10%', align: 'left'}
                ],
                columnsUsuarios: [
                    { key: '1', title: 'Rut', scopedSlots: { customRender: 'rutUsuario' }, align: 'center'},
                    { key: '2', title: 'Nombre Usuario', scopedSlots: { customRender: 'userName' }, align: 'center'},
                    { key: '3', title: 'Nombres/apellidos', scopedSlots: { customRender: 'nombreUsuario' }, align: 'center'},
                    { key: '4', title: 'Correo', scopedSlots: { customRender: 'mailUsuario' }, align: 'center'},
                    { key: '5', title: 'Habilitado', scopedSlots: { customRender: 'habilitado' }, align: 'center'},
                    { key: '6', title: 'Tipo de Usuario', scopedSlots: { customRender: 'tipoUser' }, align: 'center'},
                    { key: '7', title: 'Eliminado', scopedSlots: { customRender: 'eliminado' }, align: 'center'},
                    { key: '8', title: 'Habil. Compartir', scopedSlots: { customRender: 'habilitadoCompartir' }, align: 'center'},
                    { key: '9',title: 'Acciones', scopedSlots: { customRender: 'acciones' }, align: 'left'},
                ],
                columnsEmpresas: [
                    { slots: { title: 'customTitle' }, scopedSlots: { customRender: 'nombreEmpresa' }, width: '30%', ellipsis: true, onFilter: (value, record)=>record.idEmpresa == value},
                    { title: 'Habilitada a Cliente', scopedSlots: { customRender: 'habEmpresa' }, width: '10%', ellipsis: true, align: 'center'},
                    { title: 'Rut Empresa', scopedSlots: { customRender: 'rutEmpresa'}, width: '15%', ellipsis: true, onFilter: (value, record)=>record.rutEmpresa == value},
                    { title: 'Mensaje Ult. Actualización', scopedSlots: { customRender: 'msjAct'}, width: '40%', ellipsis: false, onFilter: (value, record)=>record.rutEmpresa == value},

                    { title: 'Acciones', scopedSlots: { customRender: 'acciones' }, width: '15%', align: 'center'}
                ],

                empresaMostrarMensaje: false,
                empresaAmostrar: null,
                columnasMensajesAct: [
                    { title: 'Cod Empresa', dataIndex: 'codEmpresa', width: '15%', ellipsis: true, align: 'center'},
                    { title: 'Mensajes', scopedSlots: { customRender: 'mensajes' }, width: '70%', align: 'left'},
                ],
                mensajesActualizacion: [],

                soloFiltradasCliente: false,

                modificarClienteModal: false,
                clienteModificar: null,

                verPropClientes: false,
                verOpcionesClientes: false

            };
        },
        beforeMount() {
            let cookieUsername = this.$cookie.get('userLogginTokenAdmin')
            if(cookieUsername === null || cookieUsername === ""){
                this.$router.push("/login/loginAdmin");
            }

            /*if(cons.intervalSesionID == null){
                this.obtenerTiempoRestante()

                var idInt = setInterval(function(){
                    this.obtenerTiempoRestante();
                }.bind(this), 5000);

                cons.intervalSesionID = idInt
            }
            
            this.obtenerTiempoRestante()*/
            this.getClientes()
        },
        beforeDestroy () {
            clearInterval(this.intervalid1)
        },

        methods: {
            obtenerTiempoRestante: function(){
                let cookieUsername = this.$cookie.get("userLogginTokenAdmin")
                
                this.tiempoRestanteSesion = (cookieUsername === null || cookieUsername === "")?"0 Minutos":formatDistance(new Date(JSON.parse(cookieUsername).fechaExpToken), new Date(), { addSuffix: true, locale: es})
            },

            getClientes: function(){
                this.isLoadingClientes = true
                var url = this.baseUrl + "/get_clientes_vapp";

                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.clientesData = result.data;
                    this.isLoadingClientes = false
                }, error => {
                        let mensaje = `Problema al obtener Clientes, ${error}`
                    this.isLoadingClientes = false
                })
                .finally(() => {
                });
            },
            agregarCliente: function(){
                var url = this.baseUrl + "/agregar_cliente/";
                this.isCreandoCliente = true

                axios({
                    method: "POST",
                    "url": url,
                    "data": {
                        "rutCliente": this.clienteNuevo.rutCliente,
                        "nombreCliente": this.clienteNuevo.nombreCliente.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
                        "rutaCarpetaBd": this.clienteNuevo.rutaCarpetaBd,
                        //"idUnidadDrive": this.clienteNuevo.idUnidadDrive,
                        "carpetaRaiz": this.clienteNuevo.carpetaRaiz,
                        "habilitarGesto": this.clienteNuevo.habilitarGesto,
                        "habilitarCompartida": this.clienteNuevo.habilitarCompartida
                        
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {

                    this.$notification.success(result.data.mensajeGeneral, {  timer: 10, position:"bottomRight"});
                    this.mensajesAgregarCliente = result.data.mensajes
                    this.mostrarMensajes = true
                    this.getClientes()
                    
                }, error => {
                        let mensaje = `Problema al obtener Clientes, ${error}`
                        this.$notification.error(error.response.data.mensajeGeneral, {  timer: 10, position:"bottomRight"});
                        
                })
                .finally(() => {
                    
                    this.isCreandoCliente = false
                });
            },
            editarCliente: function(cliente){
                cliente.respaldocliente = {
                    'nombreCliente': cliente.nombreCliente.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
                    'rutEmpresa': cliente.rutEmpresa,
                    'rutaCarpetaBd': cliente.rutaCarpetaBd,
                    'idUnidadDrive': cliente.idUnidadDrive,
                    'habilitado': cliente.habilitado,
                    "habilitarGesto": cliente.habilitarGesto,
                    "habilitarCompartida": cliente.habilitarCompartida,
                    "rutaCarpetaDrive": cliente.rutaCarpetaDrive,
                    "carpetaDefectoDrive": cliente.carpetaDefectoDrive,
                    "habilitadoPortalEmpresa": cliente.habilitadoPortalEmpresa
                }
                //this.clienteModificar = cliente
                //this.modificarClienteModal = true
                
            },
            cancelarEdicion: function(cliente){
                cliente.nombreCliente = cliente.respaldocliente.nombreCliente
                cliente.rutEmpresa = cliente.respaldocliente.rutEmpresa
                cliente.rutaCarpetaBd = cliente.respaldocliente.rutaCarpetaBd
                cliente.idUnidadDrive = cliente.respaldocliente.idUnidadDrive
                cliente.habilitado = cliente.respaldocliente.habilitado
                cliente.habilitarGesto = cliente.respaldocliente.habilitarGesto,
                cliente.habilitarCompartida = cliente.respaldocliente.habilitarCompartida
                cliente.rutaCarpetaDrive = cliente.respaldocliente.rutaCarpetaDrive
                cliente.carpetaDefectoDrive = cliente.respaldocliente.carpetaDefectoDrive
                cliente.habilitadoPortalEmpresa = cliente.respaldocliente.habilitadoPortalEmpresa

            },
            guardarEdicionCliente: function(cliente){
                
                var url = this.baseUrl + "/modificar_cliente/";
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "clienteData": cliente
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});
                    cliente.editar = false
                }, error => {
                        let mensaje = `Problema al obtener Clientes, ${error}`
                        this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight"});
                })
                .finally(() => {
                });
            },
            eliminarCliente: function(usuario){
                this.$notification.success("Eliminar Cliente no esta operativo aún", {  timer: 10, position:"bottomRight"});
            },
            configurarCliente: function(cliente){
                this.$router.push({
                    name: "ConfiguracionCliente", //use name for router push
                    params: { cliente }
                });

            },
            expandirCliente: function(expanded, cliente){
                if(expanded){
                    this.getUsuarios(cliente)
                    this.getConfigCliente(cliente)
                    this.getTablasBase(cliente)
                    this.getModulosCliente(cliente)
                }

            },

            getModulosCliente: function(cliente){
                
                var url = this.baseUrl + "/get_modulos_cliente/";

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "idCliente": cliente.idCliente
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    
                }, error => {
                })
                .finally(() => {
                });
            },

            getUsuarios: function(cliente){
                this.isLoadingUsuarios = true
                var url = this.baseUrl + "/get_usuarios_cliente";

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "idCliente": cliente.idCliente
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    cliente.usuarios = result.data;
                    this.isLoadingUsuarios = false
                    
                }, error => {
                    let mensaje = `Problema al obtener Clientes, ${error}`
                    this.isLoadingUsuarios = false
                })
                .finally(() => {
                });
            },
            editarUser: function(user){

                user.respaldoUser = {
                    "idUsuario": user.idUsuario,
                    "userName": user.userName,
                    "rutUsuario": user.rutUsuario,
                    "nombreUsuario": user.nombreUsuario,
                    "apellidoUsuario": user.apellidoUsuario,
                    "habilitado": user.habilitado,
                    "idCliente": user.idCliente,
                    "usuarioAdmin": user.usuarioAdmin,
                    "usuarioRevision": user.usuarioRevision,
                    "usuarioNormal": user.usuarioNormal,
                    "mailUsuario": user.mailUsuario,
                    "habilitadoCompartir": user.habilitadoCompartir,
                    "editar": false
                }
            },
            guardarEdicionUsuario: function(usuario){
                var url = this.baseUrl + "/modificar_usuario_cliente/";

                var cambioCompartir = usuario.respaldoUser.habilitadoCompartir != usuario.habilitadoCompartir

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "usuarioData": {
                            "usuario": usuario,
                            "cambioCompartir": cambioCompartir,
                            "cambioCorreo": usuario.respaldoUser.mailUsuario != usuario.mailUsuario,
                            "mailAnterior": usuario.respaldoUser.mailUsuario,
                            "mailNuevo": usuario.mailUsuario
                        }

                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});
                    usuario.editar = false
                }, error => {
                        let mensaje = `Problema al obtener Clientes, ${error}`
                        this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight"});
                })
                .finally(() => {
                });

            },
            eliminarUsuarioCliente: function(usuario){
                var url = this.baseUrl + "/eliminar_usuario_cliente/";

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "idUsuarioCliente": usuario.idUsuario
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});
                    usuario.usuarioEliminado = true
                    usuario.eliminar = false
                }, error => {
                        let mensaje = `Problema al obtener Clientes, ${error}`
                        this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight"});
                })
                .finally(() => {
                });
            },
            validarTipoUsuarioEdit: function(tipoUsuario,valor, usuario){
                if(tipoUsuario == "normal"){
                    if(valor){
                        usuario.usuarioAdmin = false
                        usuario.usuarioRevision = false
                    }
                }
                if(tipoUsuario == "admin"){
                     if(valor){
                        usuario.usuarioNormal = false
                        usuario.usuarioRevision = false
                     }
                }
                if(tipoUsuario == "revision"){
                    if(valor){
                        usuario.usuarioAdmin = false
                        usuario.usuarioNormal = false
                    }
                }

            },
            getEmpresasCliente: function(tipoBd, cliente){
                var url = this.baseUrl + "/get_empresas_cliente";
                cliente.isLoadingEmpresas = true

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": cliente.idCliente,
                            "tipoBd": tipoBd.idTipoBd,
                            "soloFiltradasCliente": cliente.soloFiltradasCliente
                        }
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    cliente.empresas = result.data;

                    cliente.isLoadingEmpresas = false

                    
                }, error => {
                    let mensaje = `Problema al obtener Clientes, ${error}`
                    cliente.isLoadingEmpresas = false
                })
                .finally(() => {
                });
            },

            actualizarBD: function(cliente){
                alert(cliente.idCliente)
            },
            actualizarEmpresasCliente: function(cliente){
                var url = this.baseUrl + "/actualizar_empresas_cliente";
                cliente.actualizandoInfoEmpresas = true
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": cliente.idCliente,
                            "tipoBd": cliente.tipoBdSelected.idTipoBd,
                            "soloFiltradasCliente": cliente.soloFiltradasCliente
                        }
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {

                    cliente.actualizandoInfoEmpresas = false

                    
                }, error => {
                    cliente.actualizandoInfoEmpresas = false
                })
                .finally(() => {
                });
                
            },
            guardarNuevaPropiedad: function(cliente){
                //cliente.agregandoNuevaPropiedad = true
                var url = this.baseUrl + "/agregar_propiedad_cliente";
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": cliente.idCliente,
                            "propiedad": cliente.nuevaPropiedad
                        }
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.quitarPropiedadNueva(cliente)
                    
                    this.getConfigCliente(cliente)
                    
                    this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});
                    
                }, error => {
                    this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight"});
                })
                .finally(() => {
                });
            },
            getConfigCliente: function(cliente){

                var url = this.baseUrl + "/get_config_cliente_vapp";

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": cliente.idCliente
                        }
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {

                    cliente.propiedadesCliente = result.data

                    
                }, error => {

                    this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight"});
                })
                .finally(() => {
                });
            },
            agregarNuevaPropiedad: function(cliente){
                cliente.agregarNuevaPropiedad = true
                //cliente.propiedadesCliente.push({
                cliente.nuevaPropiedad = {
                    "idPropiedad": cliente.propiedadesCliente.length+1,
                    "nombrePropiedad": "",
                    "valorPropiedad": "",
                    "editarPropiedad": false,
                    "nuevaPropiedad": true
                }
            },
            modificarPropiedad: function(cliente){
                var tablas = []

                if(cliente.propiedadSeleccionada.nombrePropiedad == 'tablas_CONTA'){                    
                    cliente.tablasBase.tablasBaseConta.forEach(tabla => {
                        if(tabla.agregada)
                            tablas.push(tabla.nombreTabla)
                    });
                    
                    cliente.propiedadSeleccionada.valorPropiedad = tablas.join(',')
                }
                else if(cliente.propiedadSeleccionada.nombrePropiedad == 'tablas_REMU'){
                    cliente.tablasBase.tablasBaseRemu.forEach(tabla => {
                        if(tabla.agregada)
                            tablas.push(tabla.nombreTabla)
                    });
                    
                    cliente.propiedadSeleccionada.valorPropiedad = tablas.join(',')
                }
                

                var url = this.baseUrl + "/modificar_propiedad_cliente";
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": cliente.idCliente,
                            "propiedad": cliente.propiedadSeleccionada
                        }
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.getConfigCliente(cliente)

                    cliente.propiedadSeleccionada.editarPropiedad = false
                    this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});
                    
                }, error => {
                    this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight"});
                })
                .finally(() => {
                });
            },
            eliminarPropiedad: function(cliente){
                var url = this.baseUrl + "/eliminar_propiedad_cliente";
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": cliente.idCliente,
                            "idPropiedad": cliente.propiedadSeleccionada.idPropiedad
                        }
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    
                    this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});
                    this.getConfigCliente(cliente)
                    
                    cliente.propiedadSeleccionada = null
                    
                }, error => {
                    this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight"});
                })
                .finally(() => {
                });
            },
            quitarPropiedadNueva: function(cliente){
                cliente.agregarNuevaPropiedad = false
                cliente.nuevaPropiedad = {
                    "idPropiedad": null,
                    "nombrePropiedad": "",
                    "valorPropiedad": "",
                    "editarPropiedad": false,
                    "nuevaPropiedad": true
                }
                /*cliente.propiedadesCliente.forEach((prop, index)=>{
                    if(prop.idPropiedad == propiedad.idPropiedad)
                        cliente.propiedadesCliente.splice(index, 1)
                })*/
            },
            mostrarMensajeActualizacion: function(empresa){
                //mensajesActualizacion: [], empresaMostrarMensaje: null,
                this.mensajesActualizacion = empresa.mensajeActualizacion
                this.empresaAmostrar = empresa
                this.empresaMostrarMensaje = true
            },
            actualizarTodoBd: function(cliente){
                var url = this.baseUrl + "/actualizar_bd_cliente";
                cliente.isUpdtEmpresas = true

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "actualizarTodoCliente": (cliente.soloFiltradasCliente)?false:true,
                            "idCliente": cliente.idCliente,
                            "empresasActualizar": [],
                            "tipoBd": cliente.tipoBdSelected.idTipoBd,
                            "admin": true
                        }
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.$notification.success(result.data.mensajeGeneral, {  timer: 10, position:"bottomRight"});
                    cliente.isUpdtEmpresas = false
                }, error => {
                    this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight"});
                    cliente.isUpdtEmpresas = false
                })
                .finally(() => {
                });
            },
            actualizarBDEmpresa: function(cliente, empresa){
                
                var url = this.baseUrl + "/actualizar_bd_cliente";
                empresa.actualizandoEmpresa = true

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "actualizarTodoCliente": false,
                            "idCliente": cliente.idCliente,
                            "empresasActualizar": [empresa],
                            "tipoBd": cliente.tipoBdSelected.idTipoBd,
                            "admin": true
                        }
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {

                    empresa.actualizandoEmpresa = false
                    empresa.mensajeActualizacion = result.data.mensajesEmpresa
                    this.$notification.success(result.data.mensajeGeneral, {  timer: 10, position:"bottomRight"});

                    
                }, error => {
                    empresa.actualizandoEmpresa = false
                    this.$notification.error(error.response.data.mensajeGeneral, {  timer: 10, position:"bottomRight"});
                })
                .finally(() => {
                });
            },
            
            seleccionarPropiedad: function(propiedad, cliente){
                var tablasPropiedad
                if(propiedad.nombrePropiedad == 'tablas_REMU'){
                    cliente.tablasBase.tablasBaseRemu.forEach(tabla => {
                        tablasPropiedad = propiedad.valorPropiedad.split(',')
                        tabla.agregada = tablasPropiedad.includes(tabla.nombreTabla)
                        //console.log(tablasPropiedad.includes(tabla.nombreTabla))

                        //tabla.agregada = false
                    })

                }
                else if(propiedad.nombrePropiedad == 'tablas_CONTA'){
                    cliente.tablasBase.tablasBaseConta.forEach(tabla => {
                        tablasPropiedad = propiedad.valorPropiedad.split(',')
                        tabla.agregada = tablasPropiedad.includes(tabla.nombreTabla)
                        //console.log(tablasPropiedad.includes(tabla.nombreTabla))

                        //tabla.agregada = false
                    })
                }

                /*cliente.propiedadesCliente.forEach((prop, index)=>{
                    if(prop.idPropiedad == propiedad.idPropiedad)
                        cliente.propiedadesCliente[index].seleccionado = true
                    else
                        cliente.propiedadesCliente[index].seleccionado = false
                })*/

            },
            
            getTablasBase: function(cliente){
                /*cliente.tablasBase = {
                    tablasBaseRemu: [{'nombreTabla':'TrabPersonal','agregada':false},{'nombreTabla':'Contratos','agregada':false},{'nombreTabla':'LockPeriodo','agregada':false}],
                    tablasBaseConta: [{'nombreTabla':'PCTA2021','agregada':false},{'nombreTabla':'PCTA2020','agregada':false},{'nombreTabla':'CLASER','agregada':false}]
                
                }*/
                var url = this.baseUrl + "/get_config_tablas_general";

                axios({
                    method: "POST", 
                    "url": url,
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    //this.tablasBase = result.data
                    cliente.tablasBase = result.data
                }, error => {
                    this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight"});
                })
                .finally(() => {
                });
            },

            formatearRut: function(rut){
                var rutaFormatear = rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
                let len = rutaFormatear.length - 1;
                if (len > 3) {
                    let dv = rutaFormatear[len];
                    let beforeDv = rutaFormatear.substring(0, len).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                    rutaFormatear = beforeDv + '-' + dv;
                }
                return rutaFormatear;
            },

            formatFecha: function(fecha){
                //return format(new Date(fechaDoc), 'EEE d LLL/yy H:mm:ss', {locale: es})//'dd/MM/yyyy' 'EEE d LLL/yy H:mm:ss'
                if(fecha != null)
                    return formatDistance(new Date(fecha), new Date(), { addSuffix: true, locale: es})//.isSame(moment().clone().startOf('day'), 'd')
                else
                    return "Nunca"
                
            },
        },
    };
</script>

<style scoped>

    .tippy-tooltip.google-theme{
    background-color:#29235C;
    font-weight: normal;
    }
    .tippy-tooltip.google-theme .tippy-backdrop {
    
    background-color:#29235C;
    }
    .tippy-content{
    background-color: transparent;
    }
    .imgr{
        -webkit-animation: 3s rotate linear infinite;
        animation: 3s rotate  linear infinite;
        -webkit-transform-origin: 50% 50%;
        transform-origin: 50% 50%;
    }
    .form-group{
    margin-top: 1rem;
    margin-bottom: 0;
    }
    .form-row{
    width: 80%;
    }

    .spinner{
        position:relative;
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
    .spinner::before, .spinner::after{
        content: "";
        position: absolute;
        border-radius: inherit;
    }
    .spinner::before{
        width: 100%;
        height: 100%;
        background-image:  linear-gradient(0deg, #B61A5A 0%, #29235C 100%);
        animation: spin .5s infinite linear;
    }
    .spinner::after{
        width: 85%;
        height: 85%;
        background-color: #ffffff;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    @keyframes spin{
        to {
            transform: rotate(360deg);
        }
    }
</style>